import React from "react";
import styled from "styled-components";

import supportIcon from '../img/support.svg';

const SupportLink = styled.div`
  display: inline-block;
  vertical-align:middle;
  margin: 0 10px 0 0;
  cursor: pointer;
  &:before {
    content: '';
    background: ${'url(' + supportIcon + ')'} no-repeat;
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
  }
  p {
    display: inline-block;
    vertical-align: middle;
    font-weight: 400;
    margin: 0 0 0 5px;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default SupportLink;



// WEBPACK FOOTER //
// ./src/styled-components/SupportLink.js